const weekdays = ["Mån", "Tis", "Ons", "Tors", "Fre", "Lör", "Sön"];

export const getWeekday = (number) => {
  return weekdays[number - 1];
};
